import React, { useContext, useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import SocketContext from "../context/SocketContext";
import { LanguageContext } from "../context/LanguageContext";

function Chat({ userId }) {
  const socket = useContext(SocketContext);
  const { lg } = useContext(LanguageContext);
  const { ambassadorId } = useParams(); // Get ambassadorId from URL
  const [message, setMessage] = useState("");
  const [messages, setMessages] = useState([]);
  const [chatStarted, setChatStarted] = useState(false);
  const [chatRequested, setChatRequested] = useState(false);
  const [chatId, setChatId] = useState(null);
  const navigate = useNavigate();

  // Redirect to login if the user is not logged in
  useEffect(() => {
    if (!userId) {
      navigate("/login"); // Redirect to login page
    }
  }, [userId, navigate]);



  // Handle sending messages
  const sendMessage = () => {
    if (!socket) {
      alert("You must be logged in to send messages.");
      return;
    }

    if (!message) {
      alert("Please enter a message");
      return;
    }

    socket.emit("send_message", { senderId: userId, receiverId: ambassadorId, chatId, message });
    setMessages((prevMessages) => [...prevMessages, { senderId: userId, message }]);
    setMessage("");
  };

  // Listen for chat acceptance
  useEffect(() => {
    if (socket) {
      socket.on("chat_accepted", ({ ambassadorId, chatId }) => {
        setChatStarted(true);
        setChatRequested(false);
        setChatId(chatId);
        console.log(`Chat started with ambassador ${ambassadorId}`);
      });

      // Listen for chat rejection
      socket.on("chat_rejected", ({ ambassadorId }) => {
        setChatRequested(false);
        console.log(`Chat request rejected by ambassador ${ambassadorId}`);
      });

      // Listen for incoming messages
      socket.on("receive_message", ({ senderId, message }) => {
        setMessages((prevMessages) => [...prevMessages, { senderId, message }]);
      });

      // Cleanup on component unmount
      return () => {
        socket.off("chat_accepted");
        socket.off("chat_rejected");
        socket.off("receive_message");
      };
    }
  }, [socket, ambassadorId]);

  return (
    <div>
      <h1>Chat with Ambassador {ambassadorId}</h1>

      {/* Request Chat Button */}
    

      {/* Chat Request Status */}
      {chatRequested && <p>Waiting for ambassador to accept your request...</p>}

      {/* Chat Messages */}
      {chatStarted && (
        <div>
          <div style={{ height: "300px", overflowY: "scroll", border: "1px solid #ccc" }}>
            {messages?.map((msg, index) => (
              <div key={index}>
                <strong>{msg.senderId}:</strong> {msg.message}
              </div>
            ))}
          </div>
          <input
            type="text"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="Type a message"
          />
          <button onClick={sendMessage}>{lg?.send || "Send"}</button>
        </div>
      )}
    </div>
  );
}

export default Chat;